class HealthReportCalculation {
  constructor() {
    this.initialize();
  }

  initialize() {
    // The 2021 form scores per question from the marks on every item, rather
    // than adding and removing points as each radio changes like 2015 does.
    this.perQuestionScoring = document.getElementById('total-score')?.dataset.scoring === 'per-question';
    this.updateTotalScore(0);
    this.bindPerQuestionScoring();
    this.bindViolationNoteToggles();
    this.bindCosCheckboxes();
    this.bindStatusRadios();
    this.bindOutOfComplianceEvent();
    this.bindTrixEditorValiation();
    this.bindSingleFieldValidation();
  }

  bindViolationNoteToggles() {
    document.querySelectorAll('[data-action="toggle-violation-notes"]').forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const container = e.target.closest('.d-grid').querySelector('.violation-notes-container');
        if (container) {
          if (e.target.checked) {
            container.style.display = 'block';
            this.updateRepeatedViolationCount(1);
          } else {
            container.style.display = 'none';
            container.querySelector('textarea').value = '';
            if (!e.target.checked) {
              this.updateRepeatedViolationCount(-1);
            }
          }
        }
      });
    });
  }

  // On the 2021 form COS is an independent mark rather than one of the status
  // radios, so its count comes from its own checkbox there.
  bindCosCheckboxes() {
    document.querySelectorAll('[data-action="toggle-cos"]').forEach((checkbox) => {
      checkbox.addEventListener('change', (e) => {
        this.updateCOSCount(e.target.checked ? 1 : -1);
      });
    });
  }

  bindStatusRadios() {
    document.querySelectorAll('input[type="radio"][name$="[status]"]').forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const questionContainer = e.target.closest('.question-container');
        const points = parseInt(questionContainer.getAttribute('data-points') || 0);
        const previousSelection = questionContainer.getAttribute('data-previous-selection');

        // Handle COS count updates
        if (e.target.value === 'cos') {
          this.updateCOSCount(1);
        } else if (previousSelection === 'cos') {
          this.updateCOSCount(-1);
        }

        if (e.target.value === 'out') {
          this.updateTotalScore(points, 'out');
        } else if (previousSelection === 'out') {
          this.updateTotalScore(-points);
        }

        // Store current selection for future reference
        questionContainer.setAttribute('data-previous-selection', e.target.value);
      });
    });
  }

  updateRepeatedViolationCount(change) {
    const repeatedViolationElement = document.querySelector('#repeated-violation .value');
    if (repeatedViolationElement) {
      let currentCount = parseInt(repeatedViolationElement.textContent.trim());
      repeatedViolationElement.textContent = currentCount + change;
    }
  }

  updateCOSCount(change) {
    const cosCountElement = document.querySelector('#cos .value');
    if (cosCountElement) {
      let currentCount = parseInt(cosCountElement.textContent.trim());
      cosCountElement.textContent = currentCount + change;
    }
  }

  // An item costs its points once if it is OUT, corrected on site or a repeat
  // violation (mirrors HealthInspectionReport#violating_responses). The score
  // floors at 0 because the form's points add up to more than 100.
  bindPerQuestionScoring() {
    if (!this.perQuestionScoring) return;

    const form = document.getElementById('health-report-form');
    form.addEventListener('change', (e) => {
      if (e.target.closest('.question-container')) this.recalculatePerQuestionScore();
    });
    this.recalculatePerQuestionScore();
  }

  recalculatePerQuestionScore() {
    let deducted = 0;
    document.querySelectorAll('.question-container').forEach((container) => {
      const violated = container.querySelector(
        'input[type="radio"][value="out"]:checked, ' +
        'input[type="checkbox"][name$="[corrected_on_site]"]:checked, ' +
        'input[type="checkbox"][name$="[repeated_violation]"]:checked'
      );
      if (violated) deducted += parseInt(container.getAttribute('data-points') || 0);
    });

    const totalScoreElement = document.getElementById('total-score');
    totalScoreElement.querySelector('.value').textContent = Math.max(100 - deducted, 0);
  }

  updateTotalScore(points) {
    // 2021 is recalculated from scratch; see recalculatePerQuestionScore.
    if (this.perQuestionScoring) return;

    const totalScoreElement = document.getElementById('total-score');
    if (totalScoreElement) {
      currentScoreDom = totalScoreElement.querySelector('.value');
      outOfDom = totalScoreElement.querySelector('.total');
      
      let currentScore = parseInt(totalScoreElement.textContent.trim());
      newScore = currentScore + points;
      
      currentScoreDom.textContent = newScore;
      outOfDom.textContent = `/${100-newScore}`;
    }
  }

  bindOutOfComplianceEvent() {
    document.querySelectorAll('input[type=radio][class=radio-button').forEach((radioBtn) => {
      radioBtn.addEventListener('click', (event) => {
        const statusRadio = event.target;
        const nonComplianceTrixGroup = document.getElementById(`non-compliance-trixs-${statusRadio.dataset.questionNumber}`);

        if(statusRadio.value == 'out' && statusRadio.checked) {
          nonComplianceTrixGroup.classList.remove('d-none');
          nonComplianceTrixGroup.querySelectorAll("trix-editor").forEach(trixInput => {
            trixInput.classList.add('active');
          });
        } else {
          nonComplianceTrixGroup.classList.add('d-none');
          nonComplianceTrixGroup.querySelectorAll("trix-editor").forEach(trixInput => {
            // Empty trix value
            trixInput.editor.loadHTML("");
            trixInput.classList.remove('active');
          })
        }

        this.toggleOutMarks(statusRadio);

        // remove if required message is shown
        document.getElementById(`required-radio-${statusRadio.dataset.questionNumber}`).classList.add('d-none');
      });
    });
  }

  // On the 2021 form COS and R only apply to an OUT item. Leaving OUT hides
  // them and unticks any that were set, firing change so the counts and score
  // follow (mirrors HealthInspectionResponse#clear_marks_unless_out).
  toggleOutMarks(statusRadio) {
    const marks = document.getElementById(`out-marks-${statusRadio.dataset.questionNumber}`);
    if (!marks || marks.dataset.requiresOut !== 'true') return;

    const isOut = statusRadio.value === 'out' && statusRadio.checked;
    marks.classList.toggle('d-none', !isOut);
    if (isOut) return;

    marks.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Validation on Form submit
  bindTrixEditorValiation() {
    const form = document.getElementById('health-report-form');

    form.addEventListener("submit", function(event) {
      let isValid = true;
      let firstInvalidEditor = null;

      document.querySelectorAll("trix-editor.active").forEach(trixEditor => {
        const inputId = trixEditor.getAttribute("input");
        const hiddenInput = document.getElementById(inputId);

        if (!hiddenInput.value.trim()) {
          isValid = false;

          if (!firstInvalidEditor) {
            firstInvalidEditor = trixEditor;
          }
        }
      });

      if (!isValid) {
        event.stopImmediatePropagation();
        event.preventDefault();
        firstInvalidEditor.focus();
      }
    });
  }

  validateSingleField(field) {
    let fieldValue = field.val();
    let fieldType = field.attr('type');

    // Remove previous error state
    field.removeClass('error-field');
    field.siblings('.error-message').remove();

    let isValid = true;

    if (fieldType === 'file') {
      if (fieldValue.length === 0 && field.attr('data-files-present') !== "true") {
        isValid = false;
      }
    } else if (fieldType === 'checkbox' || fieldType === 'radio') {
      if (!field.is(':checked')) {
        isValid = false;
      }
    } else {
      if (fieldValue.length === 0 || fieldValue.trim() === '') {
        isValid = false;
      }
    }

    if (!isValid) {
      // Add error styling and message
      field.addClass('error-field');

      // Add error message below the field
      let errorMessage = field.attr('data-error-message') || '';
      let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
      field.after(errorElement);
    }
  }

  // Validation on change or focus
  bindSingleFieldValidation() {
    const _this = this;
    // Add real-time validation for required fields
    $(document).on('blur', '.requiredField', function() {
      _this.validateSingleField($(this));
    });

    // Add real-time validation for selected fields
    $(document).on('change', '.requiredField', function() {
      _this.validateSingleField($(this));
    });

    // Add real-time validation for section response radios
    // validate radio button value first
    // also validate trixEditor if active. validate them before next radioBtn validation
    $(document).on('focus', 'input[type=radio][value=out]', function(event) {
      let validTrixValue = true;
      const currentTabActiveTrixEditors = this.closest('div[data-tab-id].tab-pane').querySelectorAll('trix-editor.active');
      currentTabActiveTrixEditors.forEach((trixEditor) => {
        _this.validateSingleField($(trixEditor));
        if(!trixEditor.value.trim()) validTrixValue = false;
      });

      if(!validTrixValue) return;

      // if focus was triggered by form submitting buttons
      if(event.relatedTarget?.tagName === 'BUTTON') {
        const requiredFieldSpan = document.getElementById(`required-radio-${this.dataset.questionNumber}`);
        requiredFieldSpan.classList.remove('d-none');
      }
    });
  }
}

// Initialize when Turbolinks loads
document.addEventListener('turbolinks:load', () => {
  const form = document.querySelector('#health-report-form');
  if (form) {
    new HealthReportCalculation();
  }
});
